import { request } from '@umijs/max';

export async function listTags(
  body: API.TagListRequest,
  options?: { [key: string]: any },
) {
  const response = await request<
    API.BackendApiResponse<API.BackendPageResult<API.TagItem>>
  >('/api/tag/list', {
    method: "POST",
    data: body,
    ...(options || {}),
  });

  return response.data.list ?? [];
}

export async function pageTags(
  body: API.TagPageRequest,
  options?: { [key: string]: any },
) {
  const response = await request<
    API.BackendApiResponse<API.BackendPageResult<API.TagItem>>
  >('/api/tag/page', {
    method: "POST",
    data: body,
    ...(options || {}),
  });
  return response.data;
}

export async function saveTag(
  body: API.TagSaveRequest,
  options?: { [key: string]: any },
) {
  const response = await request<API.BackendApiResponse<void>>('/api/tag', {
    method: "POST",
    data: body,
    ...(options || {}),
  });
  return response;
}
